import {ROUTER_ORDER_SHEET_SUBSCRIPTION} from '@web/core/routes'

export const SUBSCRIPTION_BASE_PATH = ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT.getPath()
